import { render, staticRenderFns } from "./AccountingBooksList.vue?vue&type=template&id=5e127d8c&"
import script from "./AccountingBooksList.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksList.vue?vue&type=style&index=0&id=5e127d8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports